var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { defaultSurveySelector, surveySelector } from './selectors';
import { languagePlainSelector, loggedSelector } from '../../selectors';
import { fetchDefaultSurveyIfNeeded, fetchSurveyByIdIfNeeded } from './index';
import { NOOP } from '../../utils';
export function useSurvey(idOrAlias) {
    var dispatch = useAppDispatch();
    var language = useSelector(languagePlainSelector);
    var isLoggedIn = useSelector(loggedSelector);
    var defaultSurvey = useSelector(defaultSurveySelector);
    var selectedSurvey = useSelector(function (state) {
        return surveySelector(state, idOrAlias !== null && idOrAlias !== void 0 ? idOrAlias : '');
    });
    useEffect(function () {
        if (idOrAlias) {
            dispatch(fetchSurveyByIdIfNeeded(idOrAlias)).catch(NOOP);
        }
        else {
            dispatch(fetchDefaultSurveyIfNeeded()).catch(NOOP);
        }
    }, [idOrAlias, language, isLoggedIn, dispatch]);
    var surveyState = idOrAlias ? selectedSurvey : defaultSurvey;
    return useMemo(function () {
        var loadingOnFirstFetch = !surveyState ||
            (!!surveyState.fetchingInProgressSince && !surveyState.survey);
        var loadingOnRevalidate = !!(surveyState === null || surveyState === void 0 ? void 0 : surveyState.fetchingInProgressSince) && !!(surveyState === null || surveyState === void 0 ? void 0 : surveyState.didInvalidate);
        var isLoading = Boolean(loadingOnFirstFetch || loadingOnRevalidate);
        if (!surveyState) {
            return { isLoading: isLoading };
        }
        return __assign(__assign({}, surveyState), { isLoading: isLoading });
    }, [surveyState]);
}
